<template>
  <div class="loginPage">
    <!-- <div class="bgd_right_box"
         style="position:absolute;">
      <mrc_ess_svgIcon iconClass="right"
                       class="bgd_one bgd_right_box_img" />

    </div>
    <div class="bgd_left_box"
         style="position:absolute;">
      <mrc_ess_svgIcon iconClass="left"
                       class="bgd_two bgd_left_box_img" />
    </div> -->
    <mrc_ess_svgIcon iconClass="left" class="left_bg" :style="{
      left: -bgstyle / 2 + 'px',
      width: bgstyle + 'px',
      height: bgstyle + 'px',
    }" />
    <mrc_ess_svgIcon iconClass="right" class="right_bg" :style="{
      right: -bgstyle / 2 + 'px',
      width: bgstyle + 'px',
      height: bgstyle + 'px',
    }" />

    <v-card class="logo_module pt-8" elevation="24">
      <div class="header">
        <!-- <div class="logo">
          <mrc_ess_svgIcon style="transform: scale(14);
                                    position: relative;
                                    left: 102px;
                                    top: -5px;"
                           icon-class="logoV1_ESSEnterprise_full_e_blue"></mrc_ess_svgIcon>
        </div> -->
        <mrc_ess_svgIcon style="width: 170px; height: 56px" icon-class="logoV1_ESSEnterprise_full_e_blue">
        </mrc_ess_svgIcon>
        <v-menu offset-y class="mt-4" transition="scale-transition">
          <template v-slot:activator="{ on, attrs }">
            <!-- <div v-on="on" class="" style="background: #f2f2f2">
                {{lang_name}}
                <v-icon>mdi-menu-down</v-icon>
              </div> -->
            <v-btn color="#f2f2f2" rounded text :elevation="0" height="32" class="btn"
              style="cursor: pointer !important; padding: 0 4px !important" v-bind="attrs" v-on="on">
              <!-- <mrc_ess_svgIcon icon-class="outline-language-24px"
                               style="font-size: 24px;" /> -->
              <span style="
                  text-align: left;
                  font-size: 14px;
                  color: #393939;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                " class="btntext text-capitalize px-1">
                {{ INT(lang_name) }}
              </span>
              <v-icon style="color: #393939" class="material-icons">arrow_drop_down</v-icon>
            </v-btn>
          </template>
          <v-list dense style="overflow-y: auto; max-height: 500px">
            <v-list-item v-for="item in langList" :key="item.value" @click="lang_change(item)">
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <!-- 输入框 -->
      <v-form ref="login_form" class="login_form" v-model="login_form">
        <template v-if="mode === 'auth'">
          <v-text-field v-model.trim="client_code" :disabled="auth_loading" :placeholder="$t('label_Company_client-code')"
            :rules="$text_rules($t('verify_Required'))">
          </v-text-field>
        </template>
        <template v-if="mode === 'login'">
          <!-- :label="$t('label_Company_account')" -->
          <v-text-field v-model.trim="user_account" :placeholder="$t('label_Company_account')" :disabled="login_loading"
            @input="accountUpdate" :rules="$text_rules($t('verify_Required'))">
          </v-text-field>
          <!-- @keyup.enter='login' -->
          <!-- @keyup.enter='login' -->
          <!-- :label="$t('label_password')" -->
          <v-text-field v-model.trim="user_pwd" :placeholder="$t('label_password')" :disabled="login_loading" :type="type"
            :append-icon="icon" :rules="$text_rules($t('verify_Required'))" @click:append="showPassword">
          </v-text-field>
        </template>
      </v-form>

      <div class="actions">
        <v-checkbox color="primary" dense v-model="remember" :disabled="login_loading || auth_loading"
          :label="$t('label_Remember_that_I')"></v-checkbox>
      </div>
      <v-btn :color="!countTime ? 'primary' : 'grey'" v-if="mode === 'login'" :loading="login_loading"
        :disabled="!countTime ? false : true" rounded class="login_btn d-flex justify-center align-center text-capitalize"
        @click="login">
        {{ !countTime ? $t("label_Log_in_to") : countTime }}
      </v-btn>
      <v-btn color="primary" v-if="mode === 'auth'" :loading="auth_loading" :disabled="auth_loading" rounded
        class="login_btn d-flex justify-center align-center text-capitalize" @click="toAuth">
        {{ $t("label_The_next_step") }}
      </v-btn>
      <v-btn class="text-button mt-6" v-if="mode === 'login'" style="color: rgba(0, 0, 0, 0.38)" @click="forgetPassword"
        text>
        {{ $t("label_Retrieve_password") }}
      </v-btn>
    </v-card>
    <div class="bottom">
      <p>
        © {{ new Date().getFullYear() }} MRC International Group Limited. All
        rights reserved
        <a href="https://privacy.essencehr.io/" target="_blank" class="hover1" style="
            color: #ffffff;
            text-decoration: none;
            caret-color: #fff !important;
          ">Privacy Policy</a>
        and
        <a href="https://terms.essencehr.io/" target="_blank" class="hover2" style="
            color: #ffffff;
            text-decoration: none;
            caret-color: #fff !important;
          ">Term of Use.</a>
      </p>
    </div>
    <v-overlay :value="overlay" z-index="99">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>

import mixins from "./mixins";

export default {
  components: {},
  mixins: [mixins],
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {

   },
  mounted() { },
  methods: {},
};
</script>

<style scoped>
@import "./bgd.css";

.hover1:hover {
  color: #ffffff !important;
  cursor: pointer;
}

.hover2:hover {
  color: #ffffff !important;
  cursor: pointer;
}

/deep/ .v-label {
  font-family: var(--body-font-family);
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #383838;
}

.loginPage {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  /* background: url('../../assets/img/loginBg.png') no-repeat; */
  text-align: center;
  background-color: #0f46c1;
}

.lang_name {
  font-size: 15px;
  color: #393939;
  width: 85px;
  overflow: hidden;
}

.logo_module {
  width: 480px;
  height: auth;
  padding: 0px 32px 48px 32px;
  position: absolute;
  top: 50%;
  z-index: 20;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* .btn {
  width: 180px !important;
}
.btntext {
  width: 108px;
  max-width: 108px !important;
} */
@media screen and (max-width: 375px) {
  .logo_module {
    width: 341px;
    height: 470px;
  }

  .lang_name {
    width: 64px;
  }

  /* .btn {
    width: 120px !important;
  } */
  .btntext {
    width: 50px;
    max-width: 50px !important;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 64px;
}

.login_form {
  /* width: 368px; */
  margin: 0 auto;
  font-family: var(--body-font-family);
}

.actions {
  height: 20px;
  margin-top: 5px;
  /* margin: 0 auto; */
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.actions /deep/ .v-label {
  min-width: 185px !important;
}

.login_btn {
  color: #fff;
  width: 256px;
  height: 48px !important;
  margin: 0 auto;
  margin-top: 35px;
}

.bottom {
  width: 100%;
  position: absolute;
  bottom: 5px;
  text-align: center;
  left: 50%;
  z-index: 10;
  color: rgba(255, 255, 255, 0.68);
  /* color: black; */
  transform: translateX(-50%);
  font-family: var(--body-font-family) !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 12px !important;
  line-height: 128.91% !important;
}

/* .bottom i {
  display: inline-block;
  width: 40px;
} */
.bottom p {
  letter-spacing: 1px;
  margin: 0;
}

/deep/ .v-text-field__slot {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.38);
}

/deep/ .theme--light.v-input input,
.theme--light.v-input textarea {
  /* color: rgba(0, 0, 0, 0.38); */
}

.v-list-item:hover {
  background-color: var(--main-light-color) !important;
}

.v-list-item:hover .v-list-item__title {
  color: var(--main-color) !important;
}

/* @-webkit-keyframes bgd_rotate {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes bgd_rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.bgd_left_box {
  transform: translate(-42%, 20%);
}
.bgd_right_box {
  transform: translate(40%, -57%);
}
.bgd_left_box_img {
  width: calc(64rem * 2);
  height: calc(68rem * 2);
  animation: bgd_rotate 20s ease-in-out infinite;
}
.bgd_right_box_img {
  width: calc(58rem * 4);
  height: calc(68rem * 4);
  animation: bgd_rotate 20s ease-in-out infinite;
}
@media screen and (max-width: 2000px) {
  .bgd_left_box {
    transform: translate(-42%, 20%);
  }
  .bgd_right_box {
    transform: translate(54%, -53%);
  }
  .bgd_left_box_img {
    width: calc(64rem);
    height: calc(68rem);
    animation: bgd_rotate 20s ease-in-out infinite;
  }
  .bgd_right_box_img {
    width: calc(58rem * 2);
    height: calc(68rem * 2);
    animation: bgd_rotate 20s ease-in-out infinite;
  }
}

@media screen and (max-width: 1400px) {
  .bgd_left_box {
    transform: translate(-55%, 16%);
  }
  .bgd_left_box_img {
    width: calc(64rem * 0.9);
    height: calc(68rem * 0.9);
    animation: bgd_rotate 20s ease-in-out infinite;
  }
  .bgd_right_box {
    transform: translate(54%, -32%);
  }
  .bgd_right_box_img {
    width: calc(58rem * 1.5);
    height: calc(68rem * 1.5);
    animation: bgd_rotate 20s ease-in-out infinite;
  }
}

@media screen and (max-width: 992px) {
  .bgd_left_box {
    transform: translate(-68%, 22%);
  }
  .bgd_left_box_img {
    width: calc(64rem * 0.8);
    height: calc(68rem * 0.8);
    animation: bgd_rotate 20s ease-in-out infinite;
  }
  .bgd_right_box {
    transform: translate(46%, -31%);
  }
  .bgd_right_box_img {
    width: calc(58rem * 1.5);
    height: calc(68rem * 1.5);
    animation: bgd_rotate 20s ease-in-out infinite;
  }
}
@media screen and (max-width: 800px) {
  .bgd_left_box {
    display: none;
  }
  .bgd_right_box {
    display: none;
  }
} */
</style>
